import { cmdApi } from '../../services/axios';

export const validateToken = async ( token ) => {
  
  try {
    const { data } = await cmdApi.post(
      '/auth/validate-token',
      null,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    

    // Ajusta esse trecho conforme o que teu backend retorna
    const { user, exp } = data;

    const { role, password, ...filteredUser } = user || {};
    const userWithToken = { ...filteredUser, token };

    // salva usuário
    sessionStorage.setItem('user', JSON.stringify(userWithToken));

    // monta sessão que o PrivateRoute espera
    sessionStorage.setItem('loggedIn', 'true');

    // se o backend mandar exp (segundos), usa; senão, 1h de sessão
    const expirationTime = exp
      ? exp * 1000
      : Date.now() + 60 * 60 * 1000;

    sessionStorage.setItem('expirationTime', expirationTime.toString());

    sessionStorage.setItem('authMode', 'online');

    return userWithToken;
  } catch (error) {
    console.error('Erro ao validar token:', error?.response?.data || error);
    throw error;
  }
};